import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined
} from ".."

import type { EntityStatusIconProps } from "."

export const EntityStatusIcon = (props: EntityStatusIconProps) => {
  if (props.type === "resolved") return <CheckCircleOutlined {...props} />
  if (props.type === "processing") return <ClockCircleOutlined {...props} />

  // rest of the types (dismissed, dismissed and resolved)
  return <CloseCircleOutlined {...props} />
}
